// extracted by css-extract-rspack-plugin
export default {"tab":"Tab__tab--vfks8","inner":"Tab__inner--dCw70","active":"Tab__active--iGcyQ"};